const updateOffer = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Offer/UpdateOffer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: data.offer_id,
        arabicDesc: data.content,
      }),
    });

    if (!response.ok) {
      console.error(`Error: ${response.status}`);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Fetch error:", error);
    return false;
  }
};

export default updateOffer;
